import moment from "moment";
import AppDialog from "../../../components/Common/AppDialog"
import { Box, Grid } from "@mui/material";

const VehicleDetailsSummaryModal = ({ open, close, windowWidth, selectedVehicle, bodyList, isDirectSeller, isSingPass }) => {
    return (
        <AppDialog
            open={open}
            close={close}
            vehicleData={selectedVehicle}
            title={`${selectedVehicle?.make} ${selectedVehicle?.model} ${selectedVehicle?.manu_year ? `(${selectedVehicle?.manu_year})` : ''}`}
            positiveTitle={'Close'}
            positivePress={() => close()}
            width={'45%'}
            isMobile={windowWidth <= 768 ? true : false}
        >
            <Grid container spacing={2}>
                <Grid item lg={6} md={5} sm={12} xs={12} className="subheader-3">Make / Model</Grid>
                <Grid item lg={6} md={7} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                    {selectedVehicle?.make} / {selectedVehicle?.model}
                </Grid>
                <Grid item md={6} sm={12} xs={12} className="subheader-3">Registration Number</Grid>
                <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                    {selectedVehicle?.reg_no || '-'}
                </Grid>
                {!isSingPass &&
                    <>
                        <Grid item md={6} sm={12} xs={12} className="subheader-3">Stock ID</Grid>
                        <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                            {selectedVehicle?.stock_id || '-'}
                        </Grid>
                    </>}
                {
                    selectedVehicle?.vehicle_type &&
                    <>
                        <Grid item md={6} sm={12} xs={12} className="subheader-3">Vehicle Type</Grid>
                        <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                            {selectedVehicle?.vehicle_type || '-'}
                        </Grid>
                    </>
                }
                {!isSingPass &&
                    <>
                        <Grid item md={6} sm={12} xs={12} className="subheader-3">Body Type</Grid>
                        <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                            {Array.isArray(selectedVehicle?.body_type) && selectedVehicle?.body_type.length > 0 ? selectedVehicle.body_type?.map((item, idx) => bodyList?.find((body) => body.id === item)?.name).join(', ') : selectedVehicle?.body_type || '-'}
                        </Grid>
                    </>}
                <Grid item md={6} sm={12} xs={12} className="subheader-3">Primary Colour</Grid>
                <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                    {selectedVehicle?.color || selectedVehicle?.colour || '-'}
                </Grid>
                <Grid item md={6} sm={12} xs={12} className="subheader-3">Year of Manufacture</Grid>
                <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                    {selectedVehicle?.manu_year || '-'}
                </Grid>
                <Grid item md={6} sm={12} xs={12} className="subheader-3">Registration Date</Grid>
                <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                    {selectedVehicle?.reg_date ? moment(selectedVehicle?.reg_date, "YYYY-MM-DD").format('DD-MM-YYYY') : selectedVehicle?.first_reg_date ? moment(selectedVehicle?.first_reg_date, "YYYY-MM-DD").format('DD-MM-YYYY') : '-'}
                </Grid>
                <Grid item md={6} sm={12} xs={12} className="subheader-3">Engine Capacity (CC)</Grid>
                <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                    {selectedVehicle?.engine_cc || selectedVehicle?.engine_cap || '-'}
                </Grid>
                <Grid item md={6} sm={12} xs={12} className="subheader-3">COE Category</Grid>
                <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                    {selectedVehicle?.coe_category || '-'}
                </Grid>
                <Grid item md={6} sm={12} xs={12} className="subheader-3">COE Expiry Date</Grid>
                <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                    {selectedVehicle?.coe_expiry ? moment(selectedVehicle?.coe_expiry, "YYYY-MM-DD").format('DD-MM-YYYY') : '-'}
                </Grid>
                {!isSingPass && <>
                    <Grid item md={6} sm={12} xs={12} className="subheader-3">Revision Count</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                        {selectedVehicle?.revision || '0'}
                    </Grid>
                </>}
                <Grid item md={6} sm={12} xs={12} className="subheader-3">Number of Previous Owner</Grid>
                <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                    {selectedVehicle?.no_of_owner || '0'}
                </Grid>
                <Grid item md={6} sm={12} xs={12} className="subheader-3">Mileage (KM)</Grid>
                <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                    {selectedVehicle?.mileage || '0'}
                </Grid>
                {!isSingPass &&
                    <>
                        <Grid item md={6} sm={12} xs={12} className="subheader-3">Stock Status</Grid>
                        <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                            {selectedVehicle?.stock_status || '-'}
                        </Grid>
                    </>}
                {!isDirectSeller && <>
                    <Grid item md={6} sm={12} xs={12} className="subheader-3">Purchase Cost ($)</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                        {selectedVehicle?.purchase_price ? Number(selectedVehicle?.purchase_price)?.toFixed(2) || '0.00' : '0.00'}
                    </Grid>
                    <Grid item md={6} sm={12} xs={12} className="subheader-3">Recommended Selling Price ($)</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                        {selectedVehicle?.suggested_price ? Number(selectedVehicle?.suggested_price)?.toFixed(2) || '0.00' : '0.00'}
                    </Grid>
                    <Grid item md={6} sm={12} xs={12} className="subheader-3">ARF ($)</Grid>
                    <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                        {selectedVehicle?.arf ? Number(selectedVehicle?.arf)?.toFixed(2) || '0.00' : '0.00'}
                    </Grid>
                </>
                }
                {!isSingPass &&
                    <>
                        <Grid item md={6} sm={12} xs={12} className="subheader-3">Internal Remarks</Grid>
                        <Grid item md={6} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' }, textAlign: { lg: 'end', md: 'end' } }}>
                            {selectedVehicle?.internal_remarks || '-'}
                        </Grid>
                    </>}
            </Grid>
        </AppDialog>
    )
}

export default VehicleDetailsSummaryModal;